/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
export interface TextSegment {
  text: string;
  isMatch: boolean;
}

/** Splits a string into alternating plain and highlighted segments based on a search query (case-insensitive). */
export function splitByQuery(text: string, query: string | undefined): TextSegment[] {
  if (!query || query.trim() === '') {
    return [{ text, isMatch: false }];
  }

  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const splitRegex = new RegExp(`(${escaped})`, 'gi');
  const matchRegex = new RegExp(`^${escaped}$`, 'i');

  return text
    .split(splitRegex)
    .filter((part) => part !== '')
    .map((part) => ({ text: part, isMatch: matchRegex.test(part) }));
}
